// 🔒
import { privacyPolicySections } from "../data/privacyPolicy";

export default function PrivacyPolicyPage() {
  return (
    <>
      <section className="legal-hero section">
        <div className="container legal-hero__content">
          <p className="eyebrow">LEGAL</p>
          <h1>Privacy Policy</h1>
          <p className="legal-hero__description">
            This Privacy Policy explains how personal information is collected,
            used, stored, and protected when users and trainers interact with
            the platform.
          </p>
        </div>
      </section>

      <section className="legal-content section" id="privacy-content">
        <div className="container legal-content__layout">
          <aside className="legal-sidebar">
            <p className="legal-sidebar__label">On this page</p>

            <nav
              className="legal-sidebar__nav"
              aria-label="Privacy policy sections"
            >
              {privacyPolicySections.map((section) => (
                <a key={section.id} href={`#policy-section-${section.id}`}>
                  {section.title}
                </a>
              ))}
            </nav>

            <div className="legal-sidebar__card">
              <h3>Your privacy matters</h3>
              <p>
                This page outlines the key practices that apply to personal
                information on the platform, including how data is handled,
                protected, and managed.
              </p>
            </div>
          </aside>

          <div className="legal-article">
            <div className="legal-article__meta">
              <span>Effective date: April 7, 2026</span>
            </div>

            {privacyPolicySections.map((section) => (
              <article
                key={section.id}
                id={`policy-section-${section.id}`}
                className="legal-section"
              >
                <h2>{section.title}</h2>

                {section.content.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
// 🔒